import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import WhyChooseSolution from "../components/WhyChooseSolution"
import SupportedEquipmentTypes from "../components/SupportedEquipmentTypes"
import KeyFeatures from "../components/KeyFeatures"
import GetStartedCard from "../components/GetStartedCard"
import GetInTouch from "../components/GetInTouch"
import heroBg from "../assets/hero-bg.png"
import petrolImg from "../assets/petrol.png"
import roadRollerImg from "../assets/roadroller.png"
import concretePaverImg from "../assets/concretepaver.png"
import tandemrollerImg from "../assets/tandemroller.png"
import drumMixerImg from "../assets/drumMixer.png"
import roadRoller from "../assets/roller.png"
import motorGraderImg from "../assets/motorgrader.png"
import theft from "../assets/theftprevention.png"
import tracking from "../assets/tracking.webp"
import report from "../assets/report.jpg"
import rugged from "../assets/rugged.webp"
import clouding from "../assets/clouding.jpg"
import truck from "../assets/truckk.png"
import { useState } from "react"
import fuel from "../assets/fuel-1.jpg"
import workinghours from "../assets/Working-Hours.jpg"
import liveTracking from "../assets/Live-tracking.jpg"
import frontEngine from "../assets/Front-Engine-Active-Hours.jpg"
import summer from "../assets/Summary-Reports-1.jpg"
import graph from "../assets/Graphical-Reports-1.jpg"
import cement from "../assets/cement-mixer-rotation.jpg"
import trip from "../assets/Trip-Reports-Dumper.jpg"
import cementGraph from "../assets/cement-mixer-graph.jpg"
import stoppage from "../assets/stoppage-report-dumper.jpg"
import totalload from "../assets/Total-Load.jpg"
import onoff from "../assets/concrete-pump-ignition-on-off.jpg"
import pump from "../assets/working-hour-Concrete-pump-1.jpg"
import white from "../assets/whitecement.png"
import mix from "../assets/mixpump.png"
import Excavators from "../assets/Excavators.png"
import BackhoeLoader from "../assets/Backhoe Loader.png"
import Bulldozers from "../assets/Bulldozers.png"
import loaders from "../assets/loaders.png"
import DumpTrucks from "../assets/Dump Trucks.png"
import gps from "../assets/gps.png"

const avvvImg = "/avvv.png"

const whyChooseItems = [
  {
    number: "01",
    title: "Real-Time Fuel Monitoring",
    desc: "Track fuel levels across all machinery in real time using advanced sensors and GSM-enabled GPS devices.",
    image: petrolImg,
    linkText: "Learn more",
    href: "/services",
  },
  {
    number: "02",
    title: "Fuel Theft Prevention",
    desc: "Get instant alerts for sudden drops, unauthorized fuel drains, or refueling anomalies before they impact your bottom line.",
    image: theft,
    linkText: "Learn more",
    href: "/services",
  },
  {
    number: "03",
    title: "Equipment Location Tracking",
    desc: "Know exactly where your machines are, how long they're running, and if they're idling unnecessarily across construction zones.",
    image: tracking,
    linkText: "Learn more",
    href: "/services",
  },
  {
    number: "04",
    title: "Detailed Fuel Reports",
    desc: "Access automated reports showing fuel filled, consumed, and remaining to track usage trends and spot irregularities.",
    image: report,
    linkText: "Learn more",
    href: "/services",
  },
  {
    number: "05",
    title: "Rugged Hardware",
    desc: "Use weatherproof, dust-resistant sensors built for harsh road construction site environments.",
    image: rugged,
    linkText: "Learn more",
    href: "/services",
  },
  {
    number: "06",
    title: "Cloud Dashboard",
    desc: "Monitor all sites from one dashboard with maps, reports, graphs, and fuel consumption logs.",
    image: clouding,
    linkText: "Learn more",
    href: "/services",
  },
]

const scrollToWhyChoose = () => {
  document
    .getElementById("why-choose-solution")
    ?.scrollIntoView({ behavior: "smooth" });
};

const equipmentTypes = [
  {
    title: "16-ton Road Roller",
    image: roadRollerImg,
  },
  {
    title: "Asphalt Concrete Paver",
    image: concretePaverImg,
  },
  {
    title: "Drum Mixer",
    image: drumMixerImg,
  },
  {
    title: "Tandem Roller",
    image: tandemrollerImg,
  },
  {
    title: "CAT Motor Grader",
    image: motorGraderImg,
  },
  {
    title: "Road Roller",
    image: roadRoller,
  },
]

const safetyCards = [
  {
    text: "Secure Lock-in of Tipper Bed After Unloading",
    className: "lg:left-[2%] lg:top-[34%]",
  },
  {
    text: "Auditory & Visual Indicators for Controlled Tipping Angle",
    className: "lg:right-[10%] lg:top-[4%]",
  },
  {
    text: "Ensuring Stability for Safe Tipping on Uneven Terrain",
    className: "lg:right-[4%] lg:bottom-[27%]",
  },
]

const keyBenefits = [
  {
    title: "Prevent Fuel Theft & Misuse",
    desc: "Instantly detect unauthorized fuel drains or suspicious refueling patternshelping you secure every drop of fuel.",
  },
  {
    title: "Reduce Fuel Expenses by up to 30%",
    desc: "Eliminate wastage, unauthorized usage, and over-consumption through real-time monitoring and data-driven controls.",
  },
  {
    title: "Real-Time Tracking of Machines & Fuel",
    desc: "Monitor the exact fuel level and location of every machine across your construction sites from a centralized dashboard.",
  },
  {
    title: "Improve Project Accountability",
    desc: "Get accurate records of fuel filled, consumed, and remaining — making contractors and operators more accountable.",
  },
  {
    title: "Optimize Equipment Utilization",
    desc: "Identify underused or idling machines and improve deployment planning to reduce fuel waste and operational delays.",
  },
  {
    title: "Enhance Operational Efficiency",
    desc: "Save time with automated reports, reduce manual errors, and make informed decisions that boost overall productivity.",
  },
]

const advancedFleetTabs = [
  {
    label: "Earth Moving Machinery",
    cards: [
      {
        title: "Fuel Monitoring System",
        desc: "Keep an eye on your fuel levels in real-time to safeguard against theft and make sure you’re getting the most out of every drop.",
        image: fuel,
      },
      {
        title: "Working Hours",
        desc: "Keep track of the total hours your machinery operates to schedule maintenance and ensure optimal usage.",
        image: workinghours,
      },
      {
        title: "Location and Movement",
        desc: "Use GPS or location tracking to know exactly where your machinery is and how it’s moving for better coordination and monitoring.",
        image: liveTracking,
      },
      {
        title: "Front-Engine Active Hours",
        desc: "Track active hours of different engines or parts to understand their individual usage and performance.",
        image: frontEngine,
      },
      {
        title: "Summary Reports",
        desc: "Access summary reports to quickly review key data points and trends over specific periods for informed decisions.",
        image: summer,
      },
      {
        title: "Graphical Reports",
        desc: "View graphical reports that visually represent your data, making it easier to analyze machinery performance.",
        image: graph,
      },
    ],
  },
  {
    label: "Cement Mixer Truck",
    cards: [
      {
        title: "Fuel Monitoring System",
        desc: "Keep an eye on fuel levels in real-time to prevent misuse and make sure every drop is properly tracked.",
        image: fuel,
      },
      {
        title: "Individual Clockwise & Anticlockwise Rotation Time",
        desc: "Monitor the barrel rotation time in both clockwise and anticlockwise directions to ensure efficient mixing.",
        image: cement,
      },
      {
        title: "Trip Reports",
        desc: "Generate detailed trip reports with distance, fuel consumption, and other important journey metrics.",
        image: trip,
      },
      {
        title: "Summary Reports",
        desc: "Review summary reports to understand fuel usage, activity, and performance trends over selected periods.",
        image: summer,
      },
      {
        title: "Graphical Reports",
        desc: "Analyze performance through visual reports that make operational data easier to understand.",
        image: cementGraph,
      },
    ],
  },
  {
    label: "Dumpers/Tippers",
    cards: [
      {
        title: "Total Load",
        desc: "Measure the total load carried by dumpers or tippers to keep operations within safe and efficient limits.",
        image: totalload,
      },
      {
        title: "Tilt Angle",
        desc: "Check the tilt angle during unloading to support safer dumping and reduce tipping risk.",
        image: truck,
      },
      {
        title: "Number of Stoppages",
        desc: "Count stoppages to identify frequent stopping points and optimize routes or operations accordingly.",
        image: stoppage,
      },
      {
        title: "Fuel Monitoring System",
        desc: "Track fuel levels in real-time to safeguard against theft and make sure fuel is used efficiently.",
        image: fuel,
      },
      {
        title: "Trip Reports",
        desc: "Generate trip reports with distance, fuel consumption, route activity, and other useful journey details.",
        image: trip,
      },
    ],
  },
  {
    label: "Generators/Concrete Pumps",
    cards: [
      {
        title: "Working Hours",
        desc: "Track total working hours to schedule maintenance and ensure optimal equipment usage.",
        image: pump,
      },
      {
        title: "Fuel Monitoring System",
        desc: "Monitor fuel levels in real-time to reduce fuel loss and improve operational control.",
        image: fuel,
      },
      {
        title: "Ignition On/Off Time",
        desc: "Track when your machinery is turned on and off to monitor usage patterns and identify improvement areas.",
        image: onoff,
      },
      {
        title: "Summary Reports",
        desc: "Access summary reports to quickly review equipment usage, fuel data, and performance trends.",
        image: summer,
      },
    ],
  },
]

const constructionVehicleTabs = [
  {
    label: "Cement Mixer\nTrucks",
    image: white,
    points: [
      {
        title: "Distance Traveled & Fuel Consumption:",
        desc: "It monitors the distance and the level of fuel consumption of cement mixers to improve it.",
      },
      {
        title: "Individual Clockwise & Anticlockwise Rotation Time:",
        desc: "Records the time the drum has rotated for clockwise and anti-clockwise movements.",
      },
      {
        title: "TimeTrip Reports:",
        desc: "Gives more elaborate trip duration information.",
      },
      {
        title: "Summary Reports:",
        desc: "This data provides an overall summary of essential operational data.",
      },
      {
        title: "Graphical Reports:",
        desc: "This data provides an overall summary of essential operational data.",
      },
    ],
  },
  {
    label: "Generators and\nConcrete Pumps",
    image: mix,
    points: [
      {
        title: "Working Hours:",
        desc: "This records the total working time of the equipment, helping to manage its usage time.",
      },
      {
        title: "Fuel Monitoring System:",
        desc: "Monitors fuel usage and theft to control fuel use efficiently.",
      },
      {
        title: "Ignition On/Off Time:",
        desc: "Records the running time and shutdown time of the engine to determine efficiency.",
      },
      {
        title: "Summary Reports:",
        desc: "Summarize the performance indicators through fleet management for construction to facilitate a fast & accurate analysis.",
      },
    ],
  },
  {
    label: "Excavators",
    image: Excavators,
    points: [
      {
        title: "Working Hours and Idle Hours:",
        desc: "Records working and non-working hours of Excavators, ensuring optimal equipment use.",
      },
      {
        title: "Fuel Consumption:",
        desc: "Precisely monitors fuel consumption & theft in excavators to achieve improved fuel economy and therefore cost savings.",
      },
      {
        title: "Location and Movement:",
        desc: " Offers live location updates thus assisting in monitoring movement and enhancing fleet control.",
      },
      {
        title: "Ignition On/Off Time:",
        desc: "Records ignition on & off times to enable usage enhancement and evaluation of operating processes.",
      },
      {
        title: "Summary Reports:",
        desc: " Provide an overview of key performance data related to the operation and efficiency of excavators.",
      },
      {
        title: "Graphical Reports:",
        desc: "Stimulates performance trends that make it convenient to analyze the data for usage trends.",
      },
      {
        title: "Rear-Engine Active Hours:",
        desc: "Monitors the use of the rear engine to determine its mechanical health and monitor when it needs repair or servicing.",
      },
    ],
  },
  {
    label: "Backhoe Loader\n( JCB )",
    image: BackhoeLoader,
    points: [
      {
        title: "Working Hours:",
        desc: "Keeps track of the total working time to maximize the working time as well as schedule the available time.",
      },
      {
        title: "Fuel Monitoring System:",
        desc: "The following provides records of fuel consumed to assist in maintaining operational expenses.",
      },
      {
        title: "Ignition On/Off Time:",
        desc: "Records engine on and off timings for correct usage information gathering.",
      },
      {
        title: "Summary Reports:",
        desc: " Helps in giving a brief of various operational details necessary for performance reports.",
      },
      {
        title: "Hydraulic Pressure Monitoring:",
        desc: " Monitors hydraulic pressure changes that can otherwise cause problems if not detected on time.",
      },
      {
        title: "Load Handling Capacity:",
        desc: "Monitors the weight of the loads handled, ensuring the machine is operating within safe limits.",
      },
      {
        title: "Attachment Usage Data:",
        desc: "Tracks the usage of various attachments, helping allocate resources more efficiently.",
      },
    ],
  },
  {
    label: "Bulldozers",
    image: Bulldozers,
    points: [
      {
        title: "Working Hours:",
        desc: "Keeps track of the total amount of time to optimize the machine’s utilization.",
      },
      {
        title: "Fuel Monitoring System:",
        desc: "Tracks fuel consumption to ensure monitoring of fuel Management and cost control.",
      },
      {
        title: "Blade Position and Adjustments:",
        desc: "Observe the position and movement changes of the blade to ensure precise usage.  ",
      },
      {
        title: "Ignition On/Off Time:",
        desc: "Records the time the engine is turned on and off for the exact evaluation of operational time.",
      },
      {
        title: "Summary Reports:",
        desc: "Provides an overview of key performance data to assess operational efficiency.",
      },
      {
        title: "Track Wear and Tear Monitoring:",
        desc: "Monitors the condition of the tracks to ensure timely maintenance and avoid operational disruptions.",
      },
      {
        title: "Load Handling Efficiency:",
        desc: "Records the load handling of the bulldozer to identify performance and efficiency.",
      },
    ],
  },
  {
    label: "Loaders",
    image: loaders,
    points: [
      {
        title: "Working Hours:",
        desc: " Records the operation time to make proper utilization and timing of operations.",
      },
      {
        title: "Fuel Monitoring System:",
        desc: "It helps to track fuel consumption through construction fleet tracking to enhance the fuel efficiency of a vehicle.",
      },
      {
        title: "Ignition On/Off Time:",
        desc: "Records ignition times to monitor its usage and therefore determine productivity. ",
      },
      {
        title: "Summary Reports:",
        desc: "Provide an overview of operational data to assess the output of the equipment.",
      },
      {
        title: "Load Weight and Volume Measurement:",
        desc: "Measures the weight and volume of loads, checks proper functioning and optimizes the consumption of the resources.",
      },
      {
        title: "Attachment Usage Data:",
        desc: "Keeps the record of the usage of different attachments properly functioning and optimizes the consumption of the resources.",
      },
      {
        title: "Fuel Efficiency Tracking:",
        desc: "Monitors fuel efficiency to optimize fuel consumption and reduce operational costs.",
      },
    ],
  },
  {
    label: "Dump Trucks",
    image: DumpTrucks,
    points: [
      {
        title: "Measure Total Load:",
        desc: "Records the amount of load transported by the truck, helping optimize operations and ensure proper capacity usage.",
      },
      {
        title: "Check Tilt Angle:",
        desc: "Monitors the angle of the tip when it is dumping to determine safe and efficient dumping.",
      },
      {
        title: "Vehicle Location and Number of Stoppages:",
        desc: "Records tracks and stoppages for improved management and operational planning.",
      },
      {
        title: "Fuel Monitoring System:",
        desc: "It tracks fuel usage through construction fleet tracking to optimize fuel use and, hence, cut operating costs.",
      },
      {
        title: "Trip Reports:",
        desc: " Provides detailed reports on each trip for the analysis and assessment of operation performance and productivity.",
      },
    ],
  },
]

const vehicleSoftwareBenefits = [
  {
    title: "Schedule working and idle time.",
    icon: (
      <>
        <path d="M12 7v5l3 2" />
        <path d="M21 12a9 9 0 1 1-9-9" />
        <path d="M21 3v6h-6" />
      </>
    ),
  },
  {
    title: "Monitor fuel usage and efficiency.",
    icon: (
      <>
        <path d="M4 3h9v18H4z" />
        <path d="M13 7h2.5L19 10.5V18a2 2 0 0 1-2 2h-1" />
        <path d="M7 7h3" />
        <path d="M7 12h3" />
      </>
    ),
  },
  {
    title: "Reduce fuel theft and unauthorized usage.",
    icon: (
      <>
        <path d="M12 3l7 3v5c0 5-3 8-7 10-4-2-7-5-7-10V6l7-3z" />
        <path d="M9 12l2 2 4-5" />
      </>
    ),
  },
  {
    title: "Track vehicle location in real time.",
    icon: (
      <>
        <path d="M12 21s7-5.2 7-11a7 7 0 0 0-14 0c0 5.8 7 11 7 11z" />
        <circle cx="12" cy="10" r="2.5" />
      </>
    ),
  },
  {
    title: "Improve preventive maintenance planning.",
    icon: (
      <>
        <path d="M14.7 6.3a4 4 0 0 0-5 5L4 17v3h3l5.7-5.7a4 4 0 0 0 5-5l-2.4 2.4-3-3 2.4-2.4z" />
      </>
    ),
  },
  {
    title: "Increase operator accountability.",
    icon: (
      <>
        <circle cx="9" cy="8" r="4" />
        <path d="M2 21a7 7 0 0 1 14 0" />
        <path d="M17 11l2 2 4-5" />
      </>
    ),
  },
  {
    title: "Analyze performance with smart reports.",
    icon: (
      <>
        <path d="M4 19V5" />
        <path d="M4 19h16" />
        <path d="M8 16v-5" />
        <path d="M12 16V8" />
        <path d="M16 16v-9" />
      </>
    ),
  },
  {
    title: "Reduce downtime and operating costs.",
    icon: (
      <>
        <path d="M4 7h16" />
        <path d="M6 7l1 13h10l1-13" />
        <path d="M9 7V4h6v3" />
        <path d="M9 12l6 4" />
        <path d="M15 12l-6 4" />
      </>
    ),
  },
]

const gpsDevicesImg = gps

const gpsDevicePoints = [
  {
    title: "10,000+ clients nationwide",
    icon: (
      <>
        <circle cx="9" cy="8" r="3" />
        <circle cx="17" cy="10" r="2.5" />
        <path d="M3 20a6 6 0 0 1 12 0" />
        <path d="M14 20a5 5 0 0 1 7-4.5" />
      </>
    ),
  },
  {
    title: "Professional Experts Network across India",
    icon: (
      <>
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="6" r="3" />
        <circle cx="18" cy="18" r="3" />
        <path d="M8.7 10.6 15.3 7.4" />
        <path d="M8.7 13.4 15.3 16.6" />
      </>
    ),
  },
  {
    title: "PAN India On-site support",
    icon: (
      <>
        <path d="M4 12a8 8 0 0 1 16 0" />
        <path d="M4 12v4a2 2 0 0 0 2 2h2v-7H6a2 2 0 0 0-2 2" />
        <path d="M20 12v4a2 2 0 0 1-2 2h-2v-7h2a2 2 0 0 1 2 2" />
        <path d="M13 20h3" />
      </>
    ),
  },
  {
    title: "Solutions for all industries",
    icon: (
      <>
        <path d="M4 20V9l5 3V9l5 3V6h6v14H4Z" />
        <path d="M8 16h2" />
        <path d="M13 16h2" />
        <path d="M18 16h2" />
      </>
    ),
  },
  {
    title: "Top products & service quality",
    icon: (
      <>
        <path d="M12 3 15 9l6 .9-4.5 4.3 1.1 6.1L12 17.3 6.4 20.3l1.1-6.1L3 9.9 9 9l3-6Z" />
        <path d="M10 12l1.5 1.5L15 10" />
      </>
    ),
  },
  {
    title: "Customized Telematics Solutions",
    icon: (
      <>
        <path d="M4 7h10" />
        <path d="M18 7h2" />
        <circle cx="16" cy="7" r="2" />
        <path d="M4 17h2" />
        <path d="M10 17h10" />
        <circle cx="8" cy="17" r="2" />
      </>
    ),
  },
]

export default function Section4() {
  const containerClass =
    "mx-auto w-full max-w-[1600px] px-5 sm:px-8 lg:px-12 xl:px-20"
  const [activeConstructionTab, setActiveConstructionTab] = useState(0)
  const activeConstructionData = constructionVehicleTabs[activeConstructionTab]
  const [activeFleetTab, setActiveFleetTab] = useState(0)
  const activeFleetData = advancedFleetTabs[activeFleetTab]

  return (
    <>
      <section className="relative mx-auto w-full max-w-[calc(100%-24px)] overflow-hidden rounded-b-[42px] bg-black sm:max-w-[calc(100%-32px)] lg:max-w-[calc(100%-48px)]">
        <Navbar />

        <div
          className="relative min-h-[560px] bg-cover bg-center sm:min-h-[620px] lg:min-h-[700px]"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="absolute inset-0 bg-black/68" />

          <div className="relative z-10 flex min-h-[560px] items-center justify-center px-5 pt-24 text-center sm:min-h-[620px] lg:min-h-[700px]">
            <div className="mx-auto max-w-[930px]">
              <h1 className="text-[34px] font-bold leading-tight text-white sm:text-5xl lg:text-[60px]">
                Smart Fuel Monitoring for <br className="hidden sm:block" />
                Road Construction Projects
              </h1>

              <div className="mx-auto mt-3 h-[3px] w-[240px] rounded-full bg-[#ed860f] sm:w-[420px] lg:w-[520px]" />

              <p className="mx-auto mt-7 max-w-[760px] text-sm leading-relaxed text-white/75 sm:text-base">
                Boost Operational Efficiency, Cut Fuel Losses, Ensure Accountability.
              </p>

              <div className="mt-8 flex justify-center">
                <button
                  onClick={scrollToWhyChoose}
                  className="inline-flex min-w-[210px] items-center justify-center rounded-md bg-[#ed860f] px-8 py-4 text-sm font-medium text-white transition hover:bg-[#d9780d]"
                >
                  Get started
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div id="why-choose-solution">
        <WhyChooseSolution items={whyChooseItems} />
      </div>

      <SupportedEquipmentTypes items={equipmentTypes} />

      <section className="bg-white py-14 sm:py-16 lg:py-20">
        <div className="mx-auto w-full max-w-[1180px] px-5 sm:px-8 lg:px-10">
          <div className="mx-auto max-w-[790px] text-center">
            <h2 className="text-[30px] font-bold leading-tight text-black sm:text-[38px] lg:text-[42px]">
              Dumper Rollover Safety System
            </h2>

            <p className="mx-auto mt-4 max-w-[820px] text-[15px] font-medium leading-[1.2] text-[#4f4f4f] sm:text-[17px]">
              Heavy-duty dumper trucks are essential for transporting bulk materials on
              construction and mining sites — but they also face high rollover risks
              during unloading. Unstable terrain, uneven tyres, or unlocked tipper beds
              can lead to dangerous accidents, equipment damage, and downtime.
            </p>
          </div>

          <div className="relative mx-auto mt-10 min-h-[560px] max-w-[1120px] lg:mt-8 lg:min-h-[430px]">
            <div className="relative z-10 mx-auto flex justify-center">
              <img
                src={truck}
                alt="Dumper rollover safety system"
                className="w-full max-w-[560px] object-contain drop-shadow-sm sm:max-w-[600px] lg:max-w-[600px]"
              />
            </div>

            {safetyCards.map((item, index) => (
              <div
                key={index}
                className={`relative z-20 mx-auto mt-4 flex min-h-[96px] w-[210px] flex-col items-center justify-center rounded-lg bg-white px-5 py-5 text-center shadow-[0_10px_25px_rgba(0,0,0,0.16)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_16px_32px_rgba(0,0,0,0.18)] lg:absolute lg:mt-0 ${item.className}`}
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="mx-auto mb-3"
                >
                  <path
                    d="M17.7 6.3A8 8 0 0 0 4.4 9"
                    stroke="#ed860f"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M15 6h3V3"
                    stroke="#ed860f"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.3 17.7A8 8 0 0 0 19.6 15"
                    stroke="#ed860f"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M9 18H6v3"
                    stroke="#ed860f"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <p className="text-[12px] font-medium leading-snug text-[#333333]">
                  {item.text}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-2 flex justify-center lg:mt-0">
            <a
              href="/services"
              className="inline-flex min-w-[220px] items-center justify-center rounded-md bg-[#ed860f] px-10 py-4 text-sm font-semibold text-white transition hover:bg-[#d9780d]"
            >
              Learn More
            </a>
          </div>
        </div>
      </section>

      {/* section 5  */}

      <section className="bg-white py-14 sm:py-16 lg:py-20">
        <div className="mx-auto w-full max-w-[1400px] px-5 sm:px-8 lg:px-10">
          <div className="mx-auto max-w-[820px] text-center">
            <h2 className="text-[30px] font-bold leading-tight text-black sm:text-[38px] lg:text-[42px]">
              Advanced Fleet Intelligence
            </h2>

            <p className="mx-auto mt-4 max-w-[760px] text-[15px] font-medium leading-[1.65] text-[#4f4f4f] sm:text-[17px]">
              Enhance your fleet operations with powerful monitoring, tracking, and
              analytics tools designed to improve efficiency, reduce downtime, and
              maximize asset performance.
            </p>
          </div>

          <div className="mt-12 grid gap-10 lg:grid-cols-[310px_1fr] lg:gap-12">
            <div className="flex flex-col gap-4">
              {advancedFleetTabs.map((tab, index) => (
                <button
                  key={tab.label}
                  type="button"
                  onClick={() => setActiveFleetTab(index)}
                  className={`h-[48px] rounded-md px-5 text-center text-[16px] font-medium transition duration-300 ${activeFleetTab === index
                    ? "bg-[#ed860f] text-white shadow-[0_8px_18px_rgba(237,134,15,0.25)]"
                    : "bg-[#d9d9d9] text-[#444444] hover:bg-[#ed860f] hover:text-white"
                    }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="grid gap-x-12 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
              {activeFleetData.cards.map((item, index) => (
                <div key={`${activeFleetData.label}-${index}`} className="group">
                  <div className="flex h-[118px] items-center justify-center overflow-hidden rounded-lg border border-[#eeeeee]  ">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-full w-full object-contain p-2 transition duration-300 group-hover:scale-105"
                    />
                  </div>

                  <h3 className="mt-7 text-[18px] font-bold leading-snug text-black">
                    {item.title}
                  </h3>

                  <p className="mt-3 text-[15px] font-medium leading-[1.55] text-[#4a4a4a]">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* section-6 */}

      <section className="bg-white py-14 sm:py-16 lg:py-20">
        <div className="mx-auto w-full max-w-[1180px] px-5 sm:px-8 lg:px-10">
          <div className="max-w-[850px]">
            <h2 className="text-[30px] font-bold leading-tight text-black sm:text-[38px] lg:text-[42px]">
              Comprehensive Fleet Management <br className="hidden sm:block" />
              Solutions for Construction Vehicles
            </h2>

            <p className="mt-4 max-w-[860px] text-[15px] font-medium leading-[1.65] text-[#4f4f4f] sm:text-[16px]">
              Track, monitor, and optimize every construction asset with real-time
              insights, fuel monitoring, performance analytics, and intelligent
              reporting designed to improve productivity, safety, and operational
              efficiency.
            </p>
          </div>

          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-7">
            {constructionVehicleTabs.map((tab, index) => (
              <button
                key={tab.label}
                type="button"
                onClick={() => setActiveConstructionTab(index)}
                className={`flex min-h-[58px] items-center justify-center whitespace-pre-line rounded-lg px-3 text-center text-[13px] font-semibold leading-snug transition duration-300 sm:text-[14px] ${activeConstructionTab === index
                  ? "bg-[#ed860f] text-white shadow-[0_10px_22px_rgba(237,134,15,0.25)]"
                  : "bg-[#d9d9d9] text-[#3f3f3f] hover:bg-[#ed860f] hover:text-white"
                  }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="mt-14 grid items-center gap-10 lg:grid-cols-[360px_1fr] lg:gap-16">
            <div className="flex justify-center lg:justify-start">
              <img
                src={activeConstructionData.image}
                alt={activeConstructionData.label.replace("\n", " ")}
                className="w-full max-w-[380px] object-contain transition duration-300"
              />
            </div>

            <div className="space-y-5">
              {activeConstructionData.points.map((item, index) => (
                <div
                  key={`${activeConstructionData.label}-${index}`}
                  className="flex items-start gap-5 rounded-lg bg-white px-5 py-5 shadow-[0_8px_22px_rgba(0,0,0,0.16)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_14px_30px_rgba(0,0,0,0.18)] sm:px-6"
                >
                  <div className="mt-1 shrink-0">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M17.7 6.3A8 8 0 0 0 4.4 9"
                        stroke="#ed860f"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <path
                        d="M15 6h3V3"
                        stroke="#ed860f"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M6.3 17.7A8 8 0 0 0 19.6 15"
                        stroke="#ed860f"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <path
                        d="M9 18H6v3"
                        stroke="#ed860f"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>

                  <div>
                    <h3 className="text-[16px] font-bold leading-snug text-black sm:text-[18px]">
                      {item.title}
                    </h3>

                    <p className="mt-2 text-[13px] font-medium leading-relaxed text-[#4f4f4f] sm:text-[14px]">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* section 7 */}

      <section className="bg-white py-14 sm:py-16 lg:py-20">
  <div className="mx-auto w-full max-w-[1120px] px-5 sm:px-8 lg:px-10">
    <div className="mx-auto max-w-[860px] text-center">
      <h2 className="text-[30px] font-semibold leading-tight text-black sm:text-[38px] lg:text-[42px]">
        Benefits of Using Veyonta Construction <br className="hidden sm:block" />
        Fleet Management Software in Vehicles
      </h2>

      <p className="mx-auto mt-4 max-w-[920px] text-[15px] font-medium leading-[1.65] text-[#4f4f4f] sm:text-[16px]">
        Track, monitor, and optimize every construction asset with real-time
        insights, fuel monitoring, performance analytics, and intelligent
        reporting designed to improve productivity, safety, and operational efficiency.
      </p>
    </div>

    <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {vehicleSoftwareBenefits.map((item, index) => {
  const isActive = index === 0

  return (
    <div
      key={item.title}
      className={`flex min-h-[140px] flex-col items-center justify-center rounded-lg px-6 py-7 text-center shadow-[0_9px_22px_rgba(0,0,0,0.14)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_14px_28px_rgba(0,0,0,0.18)] ${
        isActive
          ? "bg-[#ed860f] text-white"
          : "border border-[#eeeeee] bg-white text-[#333333]"
      }`}
    >
      <div
        className={`mb-5 flex h-[52px] w-[52px] items-center justify-center rounded-full ${
          isActive ? "bg-white/20 text-white" : "bg-[#fde9d3] text-[#ed860f]"
        }`}
      >
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {item.icon}
        </svg>
      </div>

      <p
        className={`max-w-[180px] text-[14px] font-medium leading-snug ${
          isActive ? "text-white" : "text-[#333333]"
        }`}
      >
        {item.title}
      </p>
    </div>
  )
})}
    </div>
  </div>
</section>

<section className="bg-white py-14 sm:py-16 lg:py-20">
  <div className="mx-auto w-full max-w-[1180px] px-5 sm:px-8 lg:px-10">
    <div className="mx-auto max-w-[860px] text-center">
      <h2 className="text-[30px] font-bold leading-tight text-black sm:text-[38px] lg:text-[42px]">
        Best GPS Devices for Construction Fleet <br className="hidden sm:block" />
        Management in India
      </h2>

      <p className="mx-auto mt-4 max-w-[780px] text-[15px] font-medium leading-[1.65] text-[#4f4f4f] sm:text-[16px]">
        Track, monitor, and optimize every construction asset with real-time
        insights, fuel monitoring, performance analytics, and intelligent
        reporting designed to improve productivity, safety, and operational
        efficiency.
      </p>
    </div>

    <div className="mt-12 grid items-center gap-10 lg:grid-cols-[1fr_1.15fr] lg:gap-14">
      <div className="space-y-5">
     {gpsDevicePoints.map((item) => (
  <div key={item.title} className="group flex items-center gap-4">
    <div className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-full bg-[#fde9d3] text-[#ed860f] transition duration-300 group-hover:bg-[#ed860f] group-hover:text-white group-hover:shadow-[0_12px_26px_rgba(237,134,15,0.25)]">
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {item.icon}
      </svg>
    </div>

    <p className="text-[15px] font-medium leading-relaxed text-[#4a4a4a] sm:text-[16px]">
      {item.title}
    </p>
  </div>
))}
      </div>

      <div className="flex justify-center lg:justify-end">
        <img
          src={gpsDevicesImg}
          alt="Best GPS devices for construction fleet management"
          className="w-full max-w-[560px] object-contain"
        />
      </div>
    </div>
  </div>
</section>


      <KeyFeatures title="Key Benefits" features={keyBenefits} />

      <section className="bg-white py-10 sm:py-12 lg:py-16">
        <div className={containerClass}>
          <GetStartedCard
            title="Get Started in Minutes"
            desc="Experience the power of automation with FleetRobo® AIS-140 ICAT Certified Devices"
            primaryText="Explore Solutions"
            secondaryText="Contact us"
            primaryHref="/services"
            secondaryHref="/contact"
          />
        </div>
      </section>

      <Footer />
    </>
  )
}